import * as React from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchHeaderMenusWP } from '../actions/headerMenus';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import renderHTML from 'react-render-html';
import * as _ from 'lodash';
import { getCookie } from '../helpers/index';

class Header extends React.Component<any, any> {

	constructor(props) {
		super(props);
	}

	componentDidMount(): void {
		this.props.fetchHeaderMenusWP({ post_type: 'menu', number: 500 });
	}

	changeLanguage = (value) => {
		this.props.i18n.changeLanguage(value);
		document.cookie = `language_landing=${value}`;
		document.location.href = '/';
	};

	showMenu = () => {
		this.props.activeMenu();
	};

	findChild = (data, par) => {
		var strg = [];
		data.map(item => {
			if (item.custom_fields[0]['value'] == par) {
				strg.push({
					post_id: item.post_id,
					link: item.custom_fields[2]['value'],
					post_excerpt: item.post_excerpt,
					post_title: item.post_title,
				});
			}
		});

		var array_map = strg.map((item) => {
			var link = '/';
			var pathname = new URL(item.link).pathname;
			link = item.link;
			if (item.post_excerpt == 0) {
				link = pathname;
			}
			return <li key={item.post_id}>
				{item.post_excerpt == 0 ? <Link to={link}>{item.post_title}</Link> :
					<a href={link} target='_blank'>{item.post_title}</a>}
			</li>;
		});

		return array_map;
	};

	render() {
		const { headerMenus } = this.props;

		var language = 'vn';

		if (getCookie('language_landing')) {
			language = getCookie('language_landing');
		}

		let headersLeft = _.filter(headerMenus.data, function (post) {
			return _.some(post.custom_fields, {
					'key': 'position',
					'value': 'lheader'
				}) && _.some(post.custom_fields, { 'key': 'language', 'value': language });
		});

		headersLeft.sort(function (menuA, menuB) {
			return menuA.post_parent - menuB.post_parent;
		});

		let headersRight = _.filter(headerMenus.data, function (post) {
			return _.some(post.custom_fields, {
					'key': 'position',
					'value': 'rheader'
				}) && _.some(post.custom_fields, { 'key': 'language', 'value': language });
		});
		headersRight.sort(function (menuA, menuB) {
			return menuA.post_parent - menuB.post_parent;
		});

		//Iterating left headers then store data in local storage
		var left_menu = headersLeft.map((item, key) => {
			var link = '/';
			var class_active = '';
			item.custom_fields.map((cField) => {
				if (cField.key == 'link') {
					var pathname = new URL(cField.value).pathname;
					link = cField.value;
					if (item.post_excerpt == 0) {
						link = pathname;
					} else {
						if(pathname == '/') {
							class_active = 'default';
							link = 'JavaScript:Void(0);';
						}
					}
				}
			});
			if (item.custom_fields[0]['value'] == '') {
				return (
					<li key={item.post_id} className="list-inline-item haschild">
						{item.post_excerpt == 0 ? <Link to={link}>{item.post_title}</Link> :
							<a className={class_active} href={link} target='_blank'>{item.post_title}</a>}
						<div className="wrapDrop">
							<ul>
								{this.findChild(headersLeft, item.post_id)}
							</ul>
						</div>
					</li>
				);
			}
		});

		//Iterating right headers then store data in local storage
		var right_menu = headersRight.map((item) => {
			var link = '/';
			item.custom_fields.map((cField) => {
				if (cField.key == 'link') {
					var pathname = new URL(cField.value).pathname;
					link = cField.value;
					if (item.post_excerpt == 0) {
						link = pathname;
					}
				}
			});
			if (item.custom_fields[0]['value'] == '') {
				return (
					<li key={item.post_id} className="list-inline-item haschild">
						{item.post_excerpt == 0 ? <Link to={link}>{item.post_title}</Link> :
							<a href={link} target='_blank'>{item.post_title}</a>}
						<div className="wrapDrop">
							<ul>
								{this.findChild(headersRight, item.post_id)}
							</ul>
						</div>
					</li>
				);
			}
		});

		var data_social: any = {};

		if (sessionStorage.getItem('data_social')) {
			data_social = JSON.parse(sessionStorage.getItem('data_social'));
		}

		return (
			<div>
				{data_social.setup_script ? renderHTML(data_social.setup_script) : ''}
				<div className="topMobile">
					<div className="container">
						<div id="divMB" onClick={this.showMenu}
						     className={this.props.active ? 'buttonMenu-Mobile active' : 'buttonMenu-Mobile'}>
				        <span className="icon-menu">
				          <div className="bar1"/>
				          <div className="bar2"/>
				          <div className="bar3"/>
				        </span>
						</div>
						<div className="logoMobile">
							<Link to="/"><img src={data_social.logo ? data_social.logo : require('../img/logo.png')}
							                  height={43}/></Link>
						</div>
						<div className="lang float-right lang-language">
							<span onClick={() => this.changeLanguage('vn')}><img src={require('../img/vn.png')}
							                                                     height={16}/></span>
							<span onClick={() => this.changeLanguage('vn')}><img src={require('../img/en.png')}
							                                                     height={16}/></span>
						</div>
					</div>
				</div>
				<div className="clearfix"/>
				<div className="header text-center">
					<div className="lang lang-language">
						<span onClick={() => this.changeLanguage('vn')}><img src={require('../img/vn.png')}
						                                                     height={16}/></span>
						<span onClick={() => this.changeLanguage('en')}><img src={require('../img/en.png')}
						                                                     height={16}/></span>
					</div>
					<div className="container" style={{ maxWidth: 1200 }}>
						<nav id="menuMB" className={this.props.active ? 'active' : ''}>
							<ul className="list-inline">
								{left_menu}
								<li className="list-inline-item logo">
									<h1 className="logo">
										<Link to="/"><img
											src={data_social.logo ? data_social.logo : require('../img/logo.png')}
											height={43}/></Link>
									</h1>
								</li>
								{right_menu}
							</ul>
						</nav>
					</div>
				</div>
				<div className="clearfix"/>
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'headerMenus'
]), mapDispatchToProps({
	fetchHeaderMenusWP
}))(translate('translations')(Header));



// WEBPACK FOOTER //
// ./src/components/Header.tsx